import { render } from "./Roster.vue?vue&type=template&id=163944ce"
import script from "./Roster.vue?vue&type=script&lang=js"
export * from "./Roster.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/ff-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__